// Module
var code = "<p>Or write to us at the AES Credit address with the following information:</p> <ul> <li>Your full name, address, and account number.</li> <li>Identification of the specific credit report tradeline disputed and details regarding the reason for the dispute. Also, enclose any supporting documentation relevant to the dispute.</li> </ul> ";
// Exports
export default code;